import { FeaturesConfig } from "~/backend/generated/Features/model/featuresConfig";

export const getFeatureNameById = (id: string, featuresConfig: FeaturesConfig): string | undefined => {
    const features = featuresConfig?.features;
    const feature = features?.find((item) => item.id === id);
    return feature?.name;
};
